import React from "react";

export default {
  id: "websiteFeedback",
  form: {
    title: "Help us improve our website",
    message: (
      <p>
        If you have comments about your online experience, please tell us on our{" "}
        {/* eslint-disable-next-line react/jsx-no-target-blank */}
        <a target="_blank" href="https://www.johnlewis.com/feedback">
          website feedback form
        </a>
        .
      </p>
    )
  },
  type: "message"
};
